var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import TimePicker from '../time-picker';
import { Styled } from '../time-picker/style';
var CustomTimeRangePicker = /** @class */ (function (_super) {
    __extends(CustomTimeRangePicker, _super);
    function CustomTimeRangePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.getAmPmInput = function () {
            var domNode = _this.timeRangePickerRef.current;
            var amPmInput = domNode.querySelectorAll('.react-time-picker__inputGroup__amPm');
            var allAmPmInput = Object.values(amPmInput);
            return allAmPmInput;
        };
        _this.handleStartChange = function (value) {
            var _a;
            var formatValue = {
                start: value,
                end: (_a = _this.props.value.end) === null || _a === void 0 ? void 0 : _a.trim(),
            };
            _this.props.onChange && _this.props.onChange(formatValue);
        };
        _this.handleEndChange = function (value) {
            var _a, _b;
            var allAmPmInput = _this.getAmPmInput();
            if (allAmPmInput.length > 0 && (navigator.language === 'en-US' || _this.props.locale === 'en-US')) {
                if (((_a = allAmPmInput[1].firstElementChild) === null || _a === void 0 ? void 0 : _a.getAttribute('selected')) === 'selected' && value === '00:00:00') {
                    value = '24:00:00';
                }
            }
            var formatValue = {
                start: (_b = _this.props.value.start) === null || _b === void 0 ? void 0 : _b.trim(),
                end: value,
            };
            _this.props.onChange && _this.props.onChange(formatValue);
        };
        _this.timeRangePickerRef = React.createRef();
        return _this;
    }
    CustomTimeRangePicker.prototype.componentDidMount = function () {
        var _a, _b;
        // Override max attribute on hour input to allow 24h format
        var allAmPmInput = this.getAmPmInput();
        if (allAmPmInput.length > 0 && ((_a = this.props.value.end) === null || _a === void 0 ? void 0 : _a.trim()) === '24:00:00' && (navigator.language === 'en-US' || this.props.locale === 'en-US')) {
            (_b = allAmPmInput[1].firstElementChild) === null || _b === void 0 ? void 0 : _b.setAttribute('selected', 'selected');
        }
    };
    CustomTimeRangePicker.prototype.render = function () {
        var _a, _b;
        var _c = this.props, className = _c.className, compact = _c.compact, disabled = _c.disabled, locale = _c.locale, showSecond = _c.showSecond, value = _c.value;
        var start = (_a = value.start) === null || _a === void 0 ? void 0 : _a.trim();
        var end = (_b = value.end) === null || _b === void 0 ? void 0 : _b.trim();
        if (start && end) {
            return (React.createElement(Styled, { className: className, compact: compact, ref: this.timeRangePickerRef, disabled: disabled },
                React.createElement(TimePicker, { value: start, onChange: this.handleStartChange, locale: locale, showSecond: showSecond, disabled: disabled }),
                React.createElement("div", { className: "path" }, "-"),
                React.createElement(TimePicker, { value: end, onChange: this.handleEndChange, minTime: start, locale: locale, showSecond: showSecond, disabled: disabled })));
        }
        return;
    };
    return CustomTimeRangePicker;
}(React.Component));
export default CustomTimeRangePicker;
//# sourceMappingURL=index.js.map